import QRCode from 'qrcode.react';
import { Component } from 'react';

import styles from "./QRCode.module.scss";
import cn from "classnames";
class QRCodeView extends Component {


  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
  }

  download() {
    const val = this.props.value.replace(/\s/g, "");
    const canvas = document.querySelector('.HpQrcode' + val + ' > canvas');
    this.downloadRef.href = canvas.toDataURL();
    this.downloadRef.download = val + "-QR.png";
  }
  render() {
    return (
      <>

        <div style={{ display: this.props.visibility ? '' : 'none' }} className={"HpQrcode" + this.props.value.replace(/\s/g, "") }>
          <QRCode
            id={this.props.value}
            value={this.props.value}
            size={140}
            level={'H'}
            includeMargin={true}
          />
        </div>
        {this.props.visibility ?
          <div className={cn(styles.flex9, styles.flex9_layout)}>
            <div className={cn(styles.flex9_spacer)} />
            <div className={cn(styles.flex9_item)} >
              <div className={cn(styles.block9, styles.block9_layout)}>
                <a
                  className={cn(
                    styles.highlights2,
                    styles.highlights2_layout
                  )}
                  onClick={() => this.download()} ref={(ref) => this.downloadRef = ref}>
                  Download
                </a>
              </div>
            </div>
          </div>
          :
          <a
            className={cn(
              styles.highlights2,
              styles.highlights2_layout
            )}
            onClick={() => this.download()} ref={(ref) => this.downloadRef = ref}>
            <img
              src={require("assets/downloads.png").default}
              style={{ margin: "8px", cursor: "pointer" }}
            ></img>
          </a>
        }

      </>
    )
  };
}

export default QRCodeView
